import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgMissing = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10 * (props.wx ?? 1)}
    height={36 * (props.hx ?? 1)}
    viewBox="0 0 10 36"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#FAFAFA'}
      stroke={props.stroke || '#E4E4E7'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M.818 26.822c.14-.775.297-1.47.51-2.036.134-.353.24-.702.263-1.079.14-2.225.57-5.304.732-8.22.195-3.504.456-6.684 1.362-10.64.448-1.96 1.031-3.84 1.537-3.847.505-.006.933 1.86.966 4.163.066 4.745.407 7.78.757 10.912.312 2.797.668 5.131.846 6.932.084.84.166 1.12.318 1.497q.08.198.205.582c.242.732 1.25 6.272.323 7.374-.616.731-1.285.941-2.258 1.545-.42.262-1.424.802-2.043.801-.733 0-1.44-.529-1.99-.868-.64-.398-1.063-.82-1.298-1.224-.722-1.243-.63-3.67-.231-5.892z"
    />
  </svg>
);
export default SvgMissing;
